import React, { Component } from 'react'
import firebase from 'firebase/app'
import 'firebase/firestore'
import './home.css'
import logo from './../../assets/images/logo.png'

var firebaseConfig = {
    apiKey: "AIzaSyC91xA0UA4cWJyfe171BmbU5LINPR0hyAo",
    authDomain: "usuariosregistradosfih.firebaseapp.com",
    databaseURL: "https://usuariosregistradosfih.firebaseio.com",
    projectId: "usuariosregistradosfih",
    storageBucket: "usuariosregistradosfih.appspot.com",
    messagingSenderId: "111738470952",
    appId: "1:111738470952:web:54d070949f58606d"
  }
  
  firebase.initializeApp(firebaseConfig);
  
  let db = firebase.firestore();


class Home extends Component {
    constructor() {
        super()
        this.state = {
          cedula: '',
          found: null,
          userName: '',
          message: '',
          user: []
        }
        this.updateCedula = this.updateCedula.bind(this)
        this.findCedula = this.findCedula.bind(this)
      }
    
      updateCedula(event) {
        this.setState({ cedula: event.target.value })
      }
    
      findCedula() {
        let cedula = parseInt(this.state.cedula)
        db.collection('users').where("Cedula", "==", cedula)
          .get()
          .then(querySnapshot => {
            if (!querySnapshot.empty) {
              let tempUser = []
              querySnapshot.forEach(doc => {
                if(doc.data().Nombre.length > 1) this.setState({ userName : doc.data().Nombre})
                let newUser = {              
                  codigo: doc.data().Codigo,
                  curso: doc.data().Curso,
                  fecha: doc.data().Fecha
                }
                tempUser.push(newUser)
              })
              this.setState({ user: tempUser, found: true })
              
            } else {
              this.setState({ found: false, message: 'El usuario no fue encontrado' })
            }
          })
          .catch(error => console.log(error))
      }
    
      render() {
        return (
          <div className="App">
            <div className="container">
              <img src={logo} className="logo" alt="Logo IFH Instructores" />
              <p><em>Ingrese el número de cédula (sin puntos) de la persona a la que desea consultar.</em></p>
              <div className="form-container">
                <p>
                  <input type="number" placeholder="Ingresa tu número de cédula" className="form-control" value={this.state.cedula} onChange={this.updateCedula} />
                </p>            
                <input type="button" value="Consultar" className="btn btn-success btn-block" onClick={this.findCedula} />
              </div>
              <div className="query-result"> 
                  {this.state.found ? (
                    <div>
                      <h4>Usuario encontrado</h4>
                      Nombre: <strong>{this.state.userName}</strong>
                      <p><small>A continuación se muestra el historial de certificaciones del usuario:</small></p>
                      {this.state.user.reverse().map(item => [
                        <div className="user-data" key={item.codigo}>
                          <div><strong>Curso realizado: </strong> {item.curso}</div>
                          <div><strong>Código del certificado: </strong> {item.codigo}</div>
                          <div><strong>Fecha de realización del curso: </strong>{item.fecha}</div>
                        </div>
                      ]
                      )}

                      <div className="warning">
                        <strong>NOTA IMPORTANTE</strong>: El dato aquí relacionado NO ES UNA CERTIFICACIÓN.
                        Este dato corresponde al REGISTRO DE INSCRIPCIÓN y en ningún momento
                        remplaza el certificado impreso que se otorga una vez culminado el
                        proceso de capacitación.
                      </div>
                    </div>               
                  ) : (
                    <div><strong>{this.state.message}</strong></div>
                  ) }              
              </div>
            </div>
          </div>
        );
    
      }
}

export default Home